define('models/wishlist-result-count',['require','chaplin','models/base/widget'],function(require) {
    'use strict';

    var Chaplin = require('chaplin');
    var Widget = require('models/base/widget');

    var WishlistResultCount = Widget.extend({
        action: 'widget.wishlistResultCount',
        defaults: {
            count: 0
        }
    });

    return WishlistResultCount;
});
